export default "__VITE_ASSET__C9d8IxHs__"